import { useState } from "react";

import { useGetLoggedIn }                                                       from "_common/hooks/auth";
import { useSetChatContainerTabName, useSetLoginPopup, useToggleChatContainer } from "_common/hooks/global";
import { LIVESESSION }                                                          from "_common/utils";
import { sendBroadcastReactions }                                               from "_services/api/engagement";
import { postLikeOnFeed }                                                       from "_services/api/feed";

import Presentation from "./presentation";

const ActionButtonsList = ( { sessionId: feedId, feedType = LIVESESSION, isLiked, isLeaderBoardLive } ) => {
	const [ showShareDrawer, setShowShareDrawer ] = useState ( isLiked );
	const [ isReacted, setIsReacted ]             = useState ( false );
	const isLoggedIn                              = useGetLoggedIn ();
	const setLoginPopup                           = useSetLoginPopup ();
	const toggleChatContainer                     = useToggleChatContainer ();
	const setChatContainerTabName                 = useSetChatContainerTabName ();

	const onClickLikeBtn = async () => {
		if ( !isLoggedIn ) {
			return setLoginPopup ( true );
		}

		if ( isReacted )
			return;

		try {
			if ( feedType === LIVESESSION ) {
				const data = {
					broadcastSessionId : feedId,
					reactionCount      : 1,
					reactionId         : 1 // Like
				};

				await sendBroadcastReactions ( data );
				setIsReacted ( true );
			} else {
				await postLikeOnFeed ( { feedId: feedId } );
				setIsReacted ( true );
			}
		} catch ( error ) {
			// api error
		}

	};

	return (
		<Presentation
			feedId                  = { feedId }
			isLeaderBoardLive       = { isLeaderBoardLive }
			isReacted               = { isReacted }
			onClickLikeBtn          = { onClickLikeBtn }
			openChat                = { () => toggleChatContainer ( true ) }
			setChatContainerTabName = { setChatContainerTabName }
			setShowShareDrawer      = { setShowShareDrawer }
			showShareDrawer         = { showShareDrawer }
		/>
	);
};

export default ActionButtonsList;